import { Spinner } from '@heroui/react';
import React from 'react';

export interface ILoadingSpinnerProps {
	label?: string;
	size?: 'sm' | 'md' | 'lg';
	spinnerClassName?: string;
}

const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({ label, size = 'sm', spinnerClassName }) => {
	return (
		<div className="flex justify-center items-center self-center h-full w-full">
			<Spinner
				label={label}
				size={size}
				classNames={{ label: 'text-msi-white-color' }}
				className={`text-msi-white-color ${spinnerClassName}`}
                color='default'
			/>
		</div>
	);
};

export default LoadingSpinner;
